// src/exp-panels/index.js
import PKPanel from './pk/PKPanel.jsx';

export const panels = {
  // experimentId → component
  pk_pilot_live_qrng: PKPanel,
};
